import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

import type { AcuityScore, UUID } from "@/core/types";
import IconArrow from "@/assets/images/icons2/icon--arrow.svg?component";
import { useCurrentAcuityScore } from "@/features/acuity/api/queries/useCurrentAcuityScore";

import { CurrentAcuityScore } from "./CurrentAcuityScore";

type Params = {
  patientId: UUID;
};

export function AcuityTransition({
  children,
}: {
  children: (acuityScore: AcuityScore) => ReactNode;
}) {
  const { patientId } = useParams<Params>();
  const { data } = useCurrentAcuityScore({ patientId });

  const effectiveScore = data?.effective_score;

  if (!effectiveScore) return null;

  return (
    <div className="tw:grid tw:grid-cols-[1fr_auto_1fr] tw:items-center tw:gap-4">
      <CurrentAcuityScore resolved_at={effectiveScore.resolved_at} score={effectiveScore.score} />

      <IconArrow className="tw:text-fill-tertiary" />

      {children(effectiveScore.score)}
    </div>
  );
}
